export default __webpack_public_path__ + "assets/images/dbf58dbb1a968c477ed6f78432eb13c6.jpg";